// Copy/metadata only. No visual styles are changed here.
const applyPositioning = () => {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;

  document.title = 'VinCentrix | Dealership Acquisition Operating System';
  let description = document.querySelector('meta[name="description"]');
  if (!description) {
    description = document.createElement('meta');
    description.name = 'description';
    document.head.appendChild(description);
  }
  description.content = 'VinCentrix helps dealerships identify, engage, appraise, acquire, and measure vehicle acquisition opportunities in one operating workflow.';

  const replacements = new Map([
    ['AI-powered CRM platform for automotive dealerships','Dealership Acquisition Operating System'],
    ['VinCentrix AI-Powered Acquisition','VinCentrix Acquisition Operating System'],
    ['1-800-555-1234','Request a demo to connect with VinCentrix']
  ]);

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes=[];
  while(walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node=>{
    const normalized=String(node.nodeValue||'').replace(/\s+/g,' ').trim();
    const replacement=replacements.get(normalized);
    if(replacement) node.nodeValue=node.nodeValue.replace(node.nodeValue.trim(),replacement);
  });
};

let queued=false;
const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;applyPositioning();});};
new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('DOMContentLoaded',schedule,{once:true});
window.addEventListener('load',schedule);
setTimeout(schedule,200);
setTimeout(schedule,1000);